import React from "react";
import Meaning from "./Meaning";
import Phonetic from "./Phonetic";

export default function Result(props) {
  console.log(props.result.phonetics);
  if (props.result) {
    return (
      <div className="Result mt-1">
        <section>
          <h1>{props.result.word}</h1>
          <h5>
            {props.result.phonetics.map(function (phonetic, index) {
              return (
                <div key={index}>
                  {phonetic.text}
                  <Phonetic phonetic={phonetic} />
                </div>
              );
            })}
          </h5>
        </section>
        {props.result.meanings.map(function (meaning, index) {
          return (
            <section key={index}>
              <Meaning meaning={meaning} />
            </section>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
